import React, { useState, useEffect } from 'react';
import { facultyCabinData } from '../data/facultyCabinData'; // Import the data
import './FacultyCabinFinder.css'; // We'll create this CSS file

const FacultyCabinFinder = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredFaculty, setFilteredFaculty] = useState(facultyCabinData); // Start with all data

  useEffect(() => {
    const searchLower = searchTerm.toLowerCase();
    
    if (searchLower === '') {
      setFilteredFaculty(facultyCabinData); // Show all if search is empty
    } else {
      const results = facultyCabinData.filter(faculty => 
        faculty.name.toLowerCase().includes(searchLower) ||
        faculty.cabin.toLowerCase().includes(searchLower) 
      );
      setFilteredFaculty(results);
    }
  }, [searchTerm]); // Re-filter when searchTerm changes

  return (
    <div className="cabin-finder-container">
      <h2>Faculty Cabin Finder</h2>
      <p>Search by faculty name or cabin number.</p>

      <div className="search-bar-container">
        <input
          type="text"
          placeholder="Enter name or cabin number..."
          className="faculty-search-bar" // Reuse existing style
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="cabin-results-container">
        {filteredFaculty.length === 0 ? (
          <p className="no-results-text">
            No faculty found matching "{searchTerm}".
          </p>
        ) : (
          <ul className="cabin-results-list">
            {filteredFaculty.map((faculty, index) => (
              <li key={index} className="cabin-result-item">
                <span className="faculty-name">{faculty.name}</span>
                <span className="cabin-number">{faculty.cabin}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default FacultyCabinFinder;